import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';
import {
  BsTelephoneFill,
  BsEnvelopeFill,
  BsGeoAltFill,
  BsInstagram
} from 'react-icons/bs';

const Contact = () => {
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '', email: '', subject: '', message: ''
  });
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs.sendForm(
      'YOUR_SERVICE_ID',      // ← replace with your Service ID
      'YOUR_TEMPLATE_ID',     // ← replace with your Template ID
      formRef.current,
      'YOUR_PUBLIC_KEY'       // ← replace with your Public Key
    ).then(() => {
      setStatus('sent');
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setStatus('idle'), 4000);
    }).catch(() => {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 4000);
    });
  };

  return (
    <section className="contact" id="contact">

      <div className="contact-label" data-aos="fade-up">
        <span className="contact-line"></span>
        <span className="contact-label-text">Get In <span>Touch</span></span>
        <span className="contact-line"></span>
      </div>

      <div className="contact-grid">

        {/* LEFT — INFO */}
        <div className="contact-info" data-aos="fade-right" data-aos-delay="100">
          <h2 className="contact-heading">
            Let's Work<br /><span>Together</span>
          </h2>
          <p className="contact-desc">
            Have a project in mind? Looking for a designer to bring
            your vision to life? I'd love to hear from you. Let's
            create something amazing together.
          </p>

          <div className="contact-details">
            <div className="contact-item">
              <div className="contact-icon-wrap"><BsTelephoneFill /></div>
              <div className="contact-item-info">
                <span className="contact-item-label">Phone</span>
                <span className="contact-item-value">+91 7988325166</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrap"><BsEnvelopeFill /></div>
              <div className="contact-item-info">
                <span className="contact-item-label">Email</span>
                <span className="contact-item-value">dkumar41413@gmail.com</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrap"><BsGeoAltFill /></div>
              <div className="contact-item-info">
                <span className="contact-item-label">Location</span>
                <span className="contact-item-value">Karnal, Haryana</span>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrap"><BsInstagram /></div>
              <div className="contact-item-info">
                <span className="contact-item-label">Instagram</span>
                <span className="contact-item-value">@mr_designer79</span>
              </div>
            </div>
          </div>

          <div className="availability">
            <div className="avail-dot"></div>
            <span>Available for Freelance Work</span>
          </div>
        </div>

        {/* RIGHT — FORM */}
        <div className="contact-form-wrap" data-aos="fade-left" data-aos-delay="200">
          <form className="contact-form" ref={formRef} onSubmit={handleSubmit}>

            <div className="form-row">
              <div className="form-group">
                <label>Your Name</label>
                <input
                  type="text"
                  name="from_name"
                  placeholder="John Doe"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Your Email</label>
                <input
                  type="email"
                  name="from_email"
                  placeholder="example@gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Subject</label>
              <input
                type="text"
                name="subject"
                placeholder="Logo Design / Branding Project"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                rows="5"
                placeholder="Tell me about your project..."
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className={`submit-btn ${status}`}
              disabled={status === 'sending'}
            >
              {status === 'idle' && (
                <><span>Send Message</span><div className="submit-arrow">→</div></>
              )}
              {status === 'sending' && (
                <><span>Sending...</span><div className="submit-spinner"></div></>
              )}
              {status === 'sent' && (
                <span>✓ Message Sent Successfully!</span>
              )}
              {status === 'error' && (
                <span>✗ Failed. Please try again.</span>
              )}
            </button>

          </form>
        </div>

      </div>
    </section>
  );
};

export default Contact;
